import Subject from "./subject";

import clsx from "clsx";

export default function SubjectGroup(props) {
  const { group, topics, step } = props;
  const { loading } = props;

  return (
    <div>
      <span
        className={`inline-block mb-4 text-lg text-emphasis-medium font-semibold uppercase fade-loading ${clsx(
          { loading }
        )}`}
      >
        {group.name}
      </span>

      <div className="topics flex flex-col md:flex-row md:flex-wrap md:-m-2 md:mb-0">
        {topics.map((topic) => {
          return (
            <div
              key={topic.slug}
              className="mb-4 md:mb-0 md:p-2 md:w-1/2 lg:w-1/3"
            >
              <Subject {...topic} loading={loading} step={step} group={group} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
